<mat-card class="content-card">

  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxFlex="70">
      <h4 *ngIf="cashbackGroup">Cashback Group {{ cashbackGroup.name }} Memberships</h4>
    </div>
    <div fxFlex="30" class="text-right">

    </div>

  </mat-card-header>

  <button mat-raised-button color="default" type="button" (click)="returnBack()">Back</button>


  <app-mat-table-generator #table
                           [saveFilters]=true
                           tableName="cashbackGroupsMembershipsTable"
                           [useEmbededFilter]="true"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="false"
                           [deleteEnabled]="false"
                           [multiselectEnabled]="false"
                           [customActions]=""
                           [viewLink]="getViewLink"
                           [defaultSortField] = "'createDate'"
                           [defaultSortDirection]="'desc'"
  >
  </app-mat-table-generator>

</mat-card>

